

















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import store from '@/services/store';
import { CUR_YEAR } from './components/js/budgetCurYear';
import { ICurBudgetVersion, ICurDataType } from './components/js/budget-header-new-interfaces';


@Component({
    name: 'c-budget-program-filter',
    components: {
    }
})


export default class CBudgetProgramFilter extends Vue {
    @Prop({
        required: true,
        default: ''
    })
    private usrId!: String;

    @Prop({
        required: true,
        default: false
    })
    private mainTableOverlay!: boolean;
    
    @Prop({
        required: true,
        default: null
    })
    private setIdArr!: Function;

    @Prop({
        required: true,
        default: 'ru'
    })
    private lng!: any

    private isComponentFirstCreation = true;
    private async created() {
        this.watchOnDataEdit();
        this.onComponentCreated();
    }

    private async onComponentCreated() {
        this.getUrl();
        this.$emit('setProgress', 5);
        await this.loadDataTypeDict();
        this.getObl();
    }

    private urlParams: {
        region?: string,
        planYear?: number,
        abp?: number,
        variant?: string,
        prg?: number | undefined,
    } = {}

    private getUrl(): void {
        const currParams = this.$route.params;
        this.urlParams = {};

        if (currParams.region) this.$set(this.urlParams, 'region', currParams.region);
        if (currParams.planYear) this.$set(this.urlParams, 'planYear', parseInt(currParams.planYear));
        if (currParams.abp) this.$set(this.urlParams, 'abp', parseInt(currParams.abp));
        if (currParams.variant) this.$set(this.urlParams, 'variant', currParams.variant);
        if (currParams.prg) this.$set(this.urlParams, 'prg', parseInt(currParams.prg));
    }

    private watchOnDataEdit() {
        this.$watch('$route.params', () => this.onRouteChanged());
        this.$watch('$store.state.user.sub', () => { this.getObl(); this.loadBudgetLevel() });
        this.$watch('$store.state._instanceCode', this.getObl, { deep: true });
        this.$watch('curYear', () => { this.loadBudgetLevel(); });
        this.$watch('curRegion', () => { this.loadBudgetVersionLatest(); });
        this.$watch(() => this.$i18n.locale, this.onLocaleChanged);
    }

    private onRouteChanged() {
        if (!this.routeChangedManually) {
            this.resetFilter();
            this.isComponentFirstCreation = true;
            this.onComponentCreated();
        }
        this.routeChangedManually = false;
    }

    private resetFilter() {
        this.curYear = {};
        this.curRegion = null;
        this.curAbp = null;
        this.curBudgetVersion = null;
    }

// =========== Регион ================
    private curRegion: any | null = null;
    private regionBase: any[] = [];

    public get regions(): any[] {
        return this.regionBase
            .map((el: any) => this.setNameLang(el, 'code'))
            .sort((a: any, b: any) => (a.code - b.code > 0) ? 1 : -1);
    }

    private async getObl() {
        let obl = null;
        const instCode = store.getters.instanceCode;
        try {
            const result = await fetch('/api-py/get-budget-obl/' + instCode)
            if (result.status === 200) {
                const json = await result.json();
                obl = json.obl;
            } else {
                this.$emit('makeToast', 'danger', 'get-budget-obl', `${result.status} - ${result.statusText}`);
            };
        } catch (error) {
            obl = null;
            this.$emit('makeToast', 'danger', this.getBPText('msg.request_budget_obl_error'), error.toString());
        }
        if (!this.usrId) { return; }
        this.regionBase = [];
        if (obl !== null) {
            try {
                await fetch('/api-py/get-user-regions-by-obl/' + obl + '/' + this.usrId)
                    .then(response => response.json())
                    .then(json => {
                        if (json.length && json[0].code) {
                            json.sort((a: any, b: any) => (a.code - b.code > 0) ? 1 : -1);
                            this.regionBase = json;
                        }
                    });
            } catch (error) {
                this.regionBase = [];
                this.$emit('makeToast', 'danger', this.getBPText('msg.request_user_region_error'), (error as Error).toString());
            }
        }
        this.region();
    }

    private region() {
        const res = this.regions;
        if (res.length > 0) { 
            if (this.urlParams.region) {
                const urlRegionIndex = res.findIndex((reg: any) => reg.code === this.urlParams.region);
                if (urlRegionIndex !== -1) this.curRegion = res[urlRegionIndex];
                else this.curRegion = res[0];
            } else this.curRegion = res[0]; 
        }
        this.$emit('setRegions', res);
    }

//====================== АБП ============================
    private abpBase: any[] = [];
    private curAbp: any | null = null;
    private budgetLevel: number[] = [];

    private get abp(): any[] {
        const res: any[] = [];
        for (const el of this.abpBase) {
            res.push(this.setNameLang(el, 'abp'));
        }
        return res;
    }

    private async loadBudgetLevel() { // загрузка уровня бюджета
        this.budgetLevel = []; 
        if (this.curRegion) {
            if (this.curRegion.code.slice(this.curRegion.code.length - 4) === '0101') {
                this.budgetLevel.push(2);
            } else if (this.curRegion.code.slice(this.curRegion.code.length - 2) === '01')  {
                this.budgetLevel.push(3);
            } else if (this.curRegion.code.slice(this.curRegion.code.length - 2) !== '00') {
                this.budgetLevel.push(4);
            }
        }
        this.loadAbp();
        this.$emit('onBudgetLevelLoaded');
    }

    private async loadAbp() { // загрузка АБП
        if (!this.budgetLevel || this.budgetLevel.length < 1 || !this.usrId) return; 
        let response: any = [];
        this.abpBase.splice(0);
        try {
            response = await fetch(`/api-py/get-dict-ved-abp-by-budgetlevel-user/${encodeURI(JSON.stringify(this.budgetLevel))}/${this.usrId}`);
            if (response.status === 200) {
                response = await response.json();
            } else {
                this.$emit('makeToast', 'danger', this.getBPText('msg.abp_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            this.$emit('makeToast', 'danger', this.getBPText('msg.abp_load_error'), error.toString());
        }

        response.sort((a: any, b: any) => (a.abp - b.abp > 0) ? 1 : -1);
        this.abpBase = this.setIdArr(response, 'abp');
        if (this.abpBase.length > 0) {
            if (this.urlParams.abp) {
                const urlAbpIndex = this.abpBase.findIndex((abp: any) => abp.abp === this.urlParams.abp);
                if (urlAbpIndex !== -1) this.curAbp = this.setNameLang(this.abpBase[urlAbpIndex], 'abp');
                else this.curAbp = this.setNameLang(this.abpBase[0], 'abp');
            } else this.curAbp = this.setNameLang(this.abpBase[0], 'abp');
        } else {
            this.curAbp = null;
        }

        this.loadBudgetVersionDict()
    }


// ====================== Плановый период ========================
    private curYear: any = {};
    private budgetVersionLatest: ICurBudgetVersion | null | {} = null;
    
    private async loadBudgetVersionLatest(): Promise<void> {
        if (!this.curRegion.code) return;
        this.budgetVersionLatest = null;
        try {
            const response = await fetch(`/api-py/get-latest-variant/${this.curRegion.code}`)
            if (response.status === 200) {
                const result = await response.json();
                if (result && result.length > 0) {
                    this.budgetVersionLatest = result[0];
                } else {
                    this.budgetVersionLatest = {};
                }
            } else {
                this.$emit('makeToast', 'danger', this.getBPText('msg.version_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.$emit('makeToast', 'danger', this.getBPText('msg.version_load_error'), error.toString());
        }
    }

    private get curPeriodFirstYear(): number {
        if (this.budgetVersionLatest && 'year' in this.budgetVersionLatest && this.budgetVersionLatest.year) {
            return this.budgetVersionLatest.year;
        }
        const currentYear = new Date().getFullYear();
        return currentYear + 1;
    }

    private get years(): any[] {
        let year = this.curPeriodFirstYear;
        if (this.urlParams.planYear) {
            year = this.urlParams.planYear;
        }
        const periodLst = [];
        const startDate = 2019;
        const endDate = year + 2;
        for (let i = endDate; i >= startDate; i--) {
            periodLst.push({ name: `${i} - ${i + 2}`, year: i });
            if (year === i) {
                this.curYear = { name: `${i} - ${i + 2}`, year: i };
            }
        }
        return periodLst;
    }


// ====================== Версия бюджета ========================
    private budgetVersionDictBase: ICurBudgetVersion[] = [];
    private curBudgetVersion: ICurBudgetVersion | null = null;

    private async loadBudgetVersionDict(): Promise<void> {
        if (!this.curYear.year || !this.curRegion.code) return;
        let result: ICurBudgetVersion[] = [];
        this.budgetVersionDictBase.splice(0);
        const data = {
            report: true
        }
        try {
            const response = await fetch(`/api-py/get-variants-by-region-year/${this.curRegion.code}/${this.curYear.year}`, 
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                })
            if (response.status === 200) {
                result = await response.json();
                this.markVersionStatus(result);
                this.budgetVersionDictBase = result;
                this.setCurBudgetVersion(result);
                this.setCurDataType();
                this.onFirstCreation();
            } else {
                this.$emit('makeToast', 'danger', this.getBPText('msg.version_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.$emit('makeToast', 'danger', this.getBPText('msg.version_load_error'), error.toString());
        }
    }

    private onFirstCreation() {
        if (this.isComponentFirstCreation) {
            // this.$emit('onCurBudgetVersionChanged', this.curBudgetVersion)
            this.$emit('setProgress', 30);
            this.$nextTick(() => {
                this.pushNewRoute();
                this.$emit('filterChanged', this.filterParams);
                this.isComponentFirstCreation = false;
            })
        }
    }

    private get variantLst(): ICurBudgetVersion[] {
        let res: ICurBudgetVersion[] = [];
        if (this.curDataType && this.curDataType.code) {
            res = this.budgetVersionDictBase.filter((item: any) => item.data_type === parseInt(this.curDataType!.code!));
            this.setCurBudgetVersion(res);
        }
        return res;
    }

    private setCurBudgetVersion(res: ICurBudgetVersion[]): void {
        if (res.length > 0) {
            if (this.urlParams.variant) {
                const currUrlVersionIndex = res.findIndex((item: any) => item.variant_uuid === this.urlParams.variant);
                if (currUrlVersionIndex !== -1) this.curBudgetVersion = res[currUrlVersionIndex];
                else this.setCurVersion(res);
            } else {
                this.setCurVersion(res);
            }
        } else {
            this.curBudgetVersion = null;
        }
    }

    private setCurVersion(res: ICurBudgetVersion[]): void {
        const activeVersion = res.find((item: any) => item.isVersionActive);
        if (activeVersion) {
            this.curBudgetVersion = activeVersion;
            return;
        }
        const approvedVersion = res
                            .filter((item: any) => item.isVersionAppruved)
                            .sort((a: any, b: any) => {
                                // null считается максимальным
                                if (a.date_ueb === null && b.date_ueb === null) {
                                    return b.id - a.id; // при равных null, сравниваем по id (больший id первый)
                                }
                                if (a.date_ueb === null) return -1; // a больше
                                if (b.date_ueb === null) return 1;  // b больше
                                
                                // если даты равны, сравниваем по id
                                if (a.date_ueb === b.date_ueb) {
                                    return b.id - a.id; // больший id первый
                                }
                                
                                return (a.date_ueb > b.date_ueb) ? -1 : 1;
                            });
        if (approvedVersion.length > 0) {
            this.curBudgetVersion = approvedVersion[0];
            return;
        }
        this.curBudgetVersion = res.sort((a: any, b: any) => b.id - a.id)[0];
    }

    private markVersionStatus(result: ICurBudgetVersion[]): void {
        result.forEach((item: ICurBudgetVersion) => {
            if (item.attribute === true && item.status === false) {
                this.$set(item, 'isVersionActive', true);
            }
            if (item.attribute === false && item.status === true) {
                this.$set(item, 'isVersionAppruved', true);
            }
        })
    }

    private versionLabel(version: any): string {
        const name = this.locName(version);
        if (version.isVersionActive) return `${name} ${this.getBPText('filter.status_active')}`;
        if (version.isVersionAppruved) return `${name} ${this.getBPText('filter.status_approved')}`;
        return name;
    }


    // ================= Раздел вид данных =========================
    private dataTypeDictBase: ICurDataType[] = [];
    private curDataType: ICurDataType | null = null;

     private get dataTypeDict(): ICurDataType[] {
        const result: ICurDataType[] = [];
        for (const el of this.dataTypeDictBase) {
            result.push(this.setNameLang(el));
        }
        return result;
    }

    // Загрузка справочника Видов данных
    private async loadDataTypeDict(): Promise<void> {
        let result: ICurDataType[] = [];
        this.dataTypeDictBase.splice(0);
        try {
            const response = await fetch('/api-py/dict_budget_data_types/')
            if (response.status === 200) {
                result = await response.json();
            } else {
                this.$emit('makeToast', 'danger', this.getBPText('msg.data_type_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            result = [];
            this.$emit('makeToast', 'danger', this.getBPText('msg.data_type_load_error'), (error as Error).toString());
        }
        this.dataTypeDictBase = result;
    }

    private setCurDataType(): void {
        if (this.curBudgetVersion && this.curBudgetVersion.data_type) {
            const curDT = this.dataTypeDictBase.find((item: any) => parseInt(item.code) === this.curBudgetVersion!.data_type!);
            if (curDT) this.curDataType = curDT;
        }
    }
    
    private locName(obj: any, kkField = 'name_kk'): string {
        return obj ? (this.$i18n.locale === 'kk' && obj[kkField]) || obj.name_ru : '';
    }

    private getBPText(field: string): string {
        return this.$t(`modules.budget_request.budget_programs.${field}`) as string;
    }

    private setNameLang(obj: any, codeName?: any | null): any {
        let txt = this.locName(obj);
        if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
            txt = obj[codeName] + ' - ' + txt;
        }
        const el = Object.assign({}, obj);
        el.name = txt;
        return el;
    }

    private relabelSelected(selected: any | null, list: any[], key: string) {
        const fresh = selected && list.find((el: any) => el[key] === selected[key]);
        if (fresh) selected.name = fresh.name;
    }

    // выбранные регион и АБП хранятся копиями со старым name, поэтому имя обновляется на месте
    private onLocaleChanged() {
        this.relabelSelected(this.curRegion, this.regions, 'code');
        this.relabelSelected(this.curAbp, this.abp, 'abp');
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.bpFilter;
        drop.show(true);
        const refItem: any = this.$refs[refName];
        setTimeout(() => refItem.$el.focus(), 100);
    }

    private chgData() {
        this.pushNewRoute(-1);
        this.$emit('filterChanged', this.filterParams);
        const drop: any = this.$refs.bpFilter;
        drop.hide(true);
    }

    private get filterParams() {
        return {
            urlParams: this.urlParams,
            curRegion: this.curRegion,
            curYear: this.curYear,
            curAbp: this.curAbp,
            curBudgetVersion: this.curBudgetVersion,
            curDataType: this.curDataType,
        }
    }
    
    private routeChangedManually = false;
    private pushNewRoute(prg: number | undefined = undefined): void {
        if (
            prg
            || !this.urlParams.region || this.urlParams.region !== this.curRegion.code
            || !this.urlParams.planYear || this.urlParams.planYear !== this.curYear.year
            || !this.urlParams.abp || this.urlParams.abp !== this.curAbp.abp
            || !this.urlParams.variant || this.urlParams.variant !== this.curBudgetVersion?.variant_uuid
        ) {
            this.routeChangedManually = true;
            const curParams = {
                    region: this.curRegion.code,
                    planYear: this.curYear.year,
                    abp: this.curAbp.abp,
                    variant: this.curBudgetVersion?.variant_uuid ? this.curBudgetVersion?.variant_uuid : ''
                };
            if (prg && prg >= 0) this.$set(curParams, 'prg', prg);

            const routeName = this.$route.name ? this.$route.name : '';
            this.$router.push({
                name: routeName, 
                params: curParams
            });
            this.getUrl();
        }
    }

    private handlePrgInRoute(prgId: number) {
        this.routeChangedManually = true;
        let newParams = {};
        if (prgId >= 0) {
            newParams = { 
                ...this.$route.params,
                prg: prgId
            }
        } else {
            const { prg, ...restParams } = this.$route.params;
            newParams = restParams;
        }
        const routeName = this.$route.name ? this.$route.name : '';
        this.$router.push({
            name: routeName,
            params: newParams
        });
    }

    private get isOpenBtnDisabled(): boolean {
        return this.mainTableOverlay 
                || !this.curBudgetVersion
                || !this.curDataType
                || !this.curAbp
                || !this.curYear
                || !this.curRegion
    }

    private onRegionChange(): void {
        this.resetUrlParams();
    }
    private resetUrlParams(): void {
        this.urlParams = {};
    }
}
